import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, useTranslation } from '@pascal/pascal-core';
import { roundTimeStore } from '../../store/roundTimeStore';
import { gameStore } from '../../store/gameStore';
import { cardsStore } from '../../store/cardsStore';
import { doBetStore } from '../../store/doBetStore';
import { getDecisionMessageKey, getWaitingMessageKey } from '../../helpers/waitingMessageKey';
// import { roundActiveHandStore } from '../../store/roundActiveHandStore';

export const DecisionTimer = observer(({ isShowTimer }) => {
  const { time, waitingText } = roundTimeStore;
  const {
    decisionDuration,
    possibleBetActions,
    hasInsurance,
    isBetsClosed,
    isSelectedDecision,
    toggleTimer,
    splitBetId,
    betId,
  } = gameStore;
  const { isShuffle } = cardsStore;
  const { lastBetModel } = doBetStore;
  const t = useTranslation();

  const waitingMessageKey = getWaitingMessageKey({
    waitingText,
    isShuffle,
    isSelectedDecision,
    isBetsClosed,
    time,
    possibleBetActions,
    lastBetModel,
    hasInsurance,
    isShowTimer,
  });

  const decisionMessageKey = getDecisionMessageKey({
    hasInsurance,
    isBetsClosed,
    time,
    possibleBetActions,
  });

  const calculateWidth = (timeArg, durationArg) => {
    if (!timeArg || !durationArg || durationArg <= 1) return '0%';
    const rawWidth = (timeArg - 1) * (100 / (durationArg - 1));
    return `${Math.min(Math.max(rawWidth, 0), 100)}%`;
  };

  const isActive = useMemo(
    () => Boolean(betId || splitBetId || !isBetsClosed),
    [betId, splitBetId]
  );

  if (!isShowTimer || !time || !decisionDuration) {
    return null;
  }

  return (
    <div className={isMobile() ? 'm-progress-info-block' : 'decisions-bets-row-head'}>
      <p className={isMobile() ? 'm-progress-info-title' : 'wait-for-next-round'}>
        {t(waitingMessageKey)}
        {t(decisionMessageKey)}
      </p>
      {!toggleTimer && isActive && (
        <div
          className={`${isMobile() ? 'm-progress-info-progress-bar' : 'decision-bets-progress'} ${
            time <= 1 ? 'red' : 'yellow'
          }`}
        >
          <div
            className={
              isMobile() ? 'm-progress-info-progress-bar-inner' : 'decision-bets-progress-bg'
            }
            style={{ width: calculateWidth(time, decisionDuration) }}
          />
        </div>
      )}
    </div>
  );
});
